<template>
  <div id="app">
      <MainComponent></MainComponent>
  </div>
</template>

<script>
  import MainComponent from "@/components/MainComponent.vue";

  export default {
    components: {
      MainComponent
    }
  }
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800;900&display=swap");
@import url("https://cdn-uicons.flaticon.com/uicons-solid-rounded/css/uicons-solid-rounded.css");

* {
  font-family: "Barlow", sans-serif;
}

html, body {
  margin: 0;
  padding: 0;
}

#app {
  margin: 0;
  padding: 0;
}
</style>

